<template>
  <div class="file-upload">
    <AppFileDragDrop
      v-model="files"
      single
      @error="showErrors"
    />

    <div class="file-upload__actions">
      <v-btn
        depressed
        color="primary"
        :loading="isFormProcessing"
        :disabled="isUploadCompleted || !files.length"
        @click="submitFiles"
      >
        Dodaj pliki
      </v-btn>
      <v-btn
        v-if="isUploadCompleted"
        depressed
        color="secondary"
        @click="clearForm"
      >
        Dodaj kolejny plik
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppFileDragDrop from '@/components/UI/AppFileDragDrop.vue';

export default {
  components: {
    AppFileDragDrop,
  },

  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      isFormProcessing: false,
      isUploadCompleted: false,
      files: [],
    };
  },

  computed: {
    allUploadsCompleted() {
      return !!this.files.length && this.files.every((file) => file.status === 'uploaded' || file.status === 'error');
    },
  },

  watch: {
    allUploadsCompleted(status) {
      if (status) {
        this.isFormProcessing = false;
        this.isUploadCompleted = true;
      }
    },
  },

  methods: {
    ...mapActions('chat', [
      'createMessage',
    ]),
    ...mapActions('snackbar', [
      'showSnackbar',
    ]),

    showErrors(errors) {
      this.showSnackbar({
        message: errors,
        type: 'error',
      });
    },

    submitFiles() {
      this.isFormProcessing = true;

      const formData = new FormData();
      formData.append('file', this.files[0].data);

      this.createMessage({ id: this.id, formData })
        .then(() => {
          this.files[0].status = 'uploaded';
        })
        .catch(() => {
          this.files[0].status = 'error';
        })
        .finally(() => {
          this.isFormProcessing = false;
        });
    },

    clearForm() {
      this.files.splice(0, this.files.length);
      this.isUploadCompleted = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-upload {
  display: block;

  &__actions {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
